import React from 'react';
import Section from 'core/components/section';
import { Card } from 'core/components/card';
import { Loading } from 'core';
import { MarketTierRating } from 'common/components/market-tier-rating';

import useStyles from './market-tier-card.styles';

const MarketTierCard = ({ marketTierRating, accountLoading }) => {
  const classes = useStyles();

  return (
    <Section>
      {accountLoading ? (
        <Loading />
      ) : (
        <Card className={classes.accountCard}>
          <MarketTierRating marketTier={marketTierRating} mode="light" />
        </Card>
      )}
    </Section>
  );
};

export default MarketTierCard;
